module.exports = __webpack_public_path__ + "media/images/eyecatch-inquiry-b383367d095c639dde4bc8eb02dd6f76.svg";